import React, { useRef } from 'react'
import { Banner } from './banner'
import { PartnerSection } from './partnerSection'

export const Partner = () => {
  const scrollRef = useRef<HTMLDivElement>(null);
  return (
    <>
    <Banner scrollRef={scrollRef}/>
    <PartnerSection ref={scrollRef}/>
    </>
  )
}
